import { LiveStreamStatus } from './presenter-enums';

export const PRESENTER_MOBILE_BREAK_POINT = 1023;
export const PRESENTER_SLIDES_ASSET_RADIX = 10;
export const SLIDE_NOT_EXIST_MESSAGE = 'Slide does not exist, please refresh the page';

export const liveStreamStatusNames = {
  [LiveStreamStatus.STAND_BY]: 'Standby',
  [LiveStreamStatus.BROADCASTING]: 'LIVE',
  [LiveStreamStatus.START_BROADCASTING]: 'LIVE',
  [LiveStreamStatus.INTERMISSION]: 'Intermission',
  [LiveStreamStatus.END_BROADCASTING]: 'Ended',
  [LiveStreamStatus.ENDED]: 'Ended'
};

// The live reports "over" in two different shapes. The REST read on load maps `live_status: 'ended'` to
// ENDED, while the onKnovioCommand subscription writes the raw command type, so a broadcast ended while
// the presenter is watching lands as END_BROADCASTING. Same terminal state — liveStreamStatusNames above
// already labels both "Ended" — so anything reacting to the live finishing has to accept either.
export const isLiveStreamEnded = (status: LiveStreamStatus): boolean =>
  status === LiveStreamStatus.ENDED || status === LiveStreamStatus.END_BROADCASTING;

export const liveStreamStatusFromApi = (status: string): LiveStreamStatus => {
  switch (status){
    case 'standBy':
      return LiveStreamStatus.STAND_BY;
    case 'broadcasting':
      return LiveStreamStatus.BROADCASTING;
    case 'intermission':
      return LiveStreamStatus.INTERMISSION;
    case 'ended':
      return LiveStreamStatus.ENDED;
    default:
      return LiveStreamStatus.STAND_BY;
  }
};